export interface AddEmojiToInputProp {
  input: HTMLInputElement | HTMLTextAreaElement;
  emoji: string;
}

/**
 * Adds the emoji to the actual input, considering the current cursor's focus
 */
export function addEmojiToInput({ input, emoji }: AddEmojiToInputProp): string {
  const cursor = input.selectionStart as number;

  const newCursor = cursor + emoji.length;
  setTimeout(() => input?.setSelectionRange(newCursor, newCursor), 10);

  return input.value.slice(0, cursor) + emoji + input.value.slice(cursor);
}
